import { Card, CardContent, CardHeader, CardTitle } from '@1trading/react';
import { CircleCheck, CircleX } from 'lucide-react';
import { GUARD_LABEL } from '@/features/fee-runs/fee-run-helpers';
import type { GuardResult } from '@/services/api/fee-runs';

/** The safety checks evaluated at calculation (and again at approval); a failing one blocks approval. */
export const FeeRunGuards = ({ guards, approvable }: { guards: GuardResult[]; approvable: boolean | undefined }) => (
  <Card>
    <CardHeader className="flex flex-row flex-wrap items-center justify-between gap-3 space-y-0">
      <CardTitle>Safety checks</CardTitle>
      {approvable === false ? <span className="text-sm text-red-500">Approval blocked</span> : null}
    </CardHeader>
    <CardContent>
      <ul className="flex flex-col gap-2">
        {guards.map((guard) => (
          <li className="flex items-start gap-2 text-sm" key={guard.name}>
            {guard.passed ? (
              <CircleCheck aria-label="passed" className="mt-0.5 size-4 shrink-0 text-emerald-500" />
            ) : (
              <CircleX aria-label="failed" className="mt-0.5 size-4 shrink-0 text-red-500" />
            )}
            <div className="flex flex-col">
              <span className="font-medium">{GUARD_LABEL[guard.name]?.title ?? guard.name}</span>
              <span className="text-muted-foreground">{guard.detail}</span>
            </div>
          </li>
        ))}
      </ul>
    </CardContent>
  </Card>
);
FeeRunGuards.displayName = 'FeeRunGuards';
